import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ShareDirectivesModule } from '../../../core/directives/directives.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { MaterialModule } from '../../modules/material/material.module';
import { PdfReaderComponent } from './pdf-reader.component';

@NgModule({
  declarations: [
    PdfReaderComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ShareDirectivesModule,
    ReactiveFormsModule,
    TranslationModule,
  ],
  exports: [
    PdfReaderComponent
  ]
})
export class PdfReaderModule { }
